<div class="flex flex-row justify-between  whitespace-nowrap overflow-x-auto gap-4" (click)="showAbsoluteValues = !showAbsoluteValues">
  <!-- added grid-cols-5 to have it in the environment -->
  @for (score of vitascores; track $index) {
    <div class="">
      <img class="mx-auto mt-2.5 h-10" height="40px" [width]="score.imageWidth" [alt]="score.alt" [src]="score.src" loading="lazy"/>
      <div class="flex flex-col justify-center items-center my-[15px]">
        <span class="text-sm">
          @if (score.alt.includes('co2')) {<span>CO<sub>2</sub></span>}
          {{ score.label | translate}}
        </span>
        @if (score?.score?.scoreimprovementpercentage) {
          <span class="text-sm whitespace-nowrap">
            @if (score.score.scoreimprovementpercentage > 0) {+}
              {{ (score?.score?.scoreimprovementpercentage || 0) | percent: '1.0-0'}}
            </span>
          }
          @if (showAbsoluteValues) {
            <span class="text-xs mt-1 text-center opacity-75 " @collapse>
              @if(score.score.scoreimprovementpercentage > 0 && score.score.scoreimprovement > 0){+}
                @if (score.unit !== 'CURRENCY') {
                  {{ (score.score.scoreimprovement || 0) | number: '1.0-1'}} {{ score.unitPrefix + score.unit |translate}}
                  }@else {
                  {{ (score.score.scoreimprovement || 0) |currency: 'EUR':'symbol':'.2-2':'nl'}}
                }
              </span>
            }
          </div>
        </div>
      }

    </div>
    <div class="flex flex-row justify-between">
      <small class="mb-2 underline"><a routerLink="/{{'score.learn_more_url' | translate}}">{{'score.learn_more' | translate}}</a></small>
      <small class="mt-1 text-xs">{{'score.note' |translate}}</small>
    </div>
